export const userStatusOptions = [
  {
    value: 'all',
    label: 'All',
  },
  {
    value: 'active',
    label: 'Active',
  },
  {
    value: 'archived',
    label: 'Inactive',
  },
];

export const userRegistrationStatusOptions = [
  {
    value: 'all',
    label: 'All',
  },
  {
    value: 'completed',
    label: 'Completed',
  },
  {
    value: 'incomplete',
    label: 'Incomplete',
  },
];

// "All" system roles is sent to the API as an empty list of ids
export const allRolesOption = { value: [], label: 'All' };
